import { default as _91slug_wagtail_93wUTFDgZasRMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/[slug_wagtail].vue?macro=true";
import { default as accessibilityNi7USv4ISsMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accessibility.vue?macro=true";
import { default as deletemgb8oFqj77Meta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/addresses/[addressId]/delete.vue?macro=true";
import { default as indexo02gzzJDnoMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/addresses/[addressId]/index.vue?macro=true";
import { default as add5AvRQJWdqfMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/addresses/add.vue?macro=true";
import { default as indexCe7NQw5FLIMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/addresses/index.vue?macro=true";
import { default as index41jti2oVvPMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/change-password/index.vue?macro=true";
import { default as index7LU7OFe28ZMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/credits/index.vue?macro=true";
import { default as emailhmBvQnEC5RMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/email.vue?macro=true";
import { default as _91id_93uIkEpqej2mMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/orders/[id].vue?macro=true";
import { default as index1EIjAgzHRWMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/orders/gifts/index.vue?macro=true";
import { default as indexdbE6cP7HPeMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/orders/index.vue?macro=true";
import { default as _91id_93ON9923I97fMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/orders/weather/[id].vue?macro=true";
import { default as deletey0I1YjHGrEMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/payment_methods/[methodId]/delete.vue?macro=true";
import { default as updateaxBammrT5XMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/payment_methods/[methodId]/update.vue?macro=true";
import { default as addoiycAytqJaMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/payment_methods/add.vue?macro=true";
import { default as indexhQUYxYxXFfMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/payment_methods/index.vue?macro=true";
import { default as editlgBnhUrYPWMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/profile/edit.vue?macro=true";
import { default as indexdtlUEkLGUwMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/profile/index.vue?macro=true";
import { default as unsubscribeoiJ3b1yP3qMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/unsubscribe.vue?macro=true";
import { default as indexcKAQ2qCnl2Meta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/basket/quick-add/index.vue?macro=true";
import { default as indexMeWEv6BtDhMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/basket/quick-multiple/index.vue?macro=true";
import { default as cartdlBaI0dIfvMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/cart.vue?macro=true";
import { default as _91slug_93HIh20MpmNeMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/catalog/[slug].vue?macro=true";
import { default as _91slug_934PPZgve5OJMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/catalog/category/[slug].vue?macro=true";
import { default as indexiCvi6GMBNJMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/catalog/index.vue?macro=true";
import { default as _91id_93Xpuol14a38Meta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/cellar/lists/[id].vue?macro=true";
import { default as indexnemGqhxALMMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/cellar/lists/index.vue?macro=true";
import { default as savedSwCSS1pRC4Meta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/cellar/saved.vue?macro=true";
import { default as _91_91slug_93_934yZUwkpO6oMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/cellar/wines/[[slug]].vue?macro=true";
import { default as indexdCCe2cmdWIMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/champagne-club/index.vue?macro=true";
import { default as indexJzwcFNuwO8Meta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/champagne-club/join/index.vue?macro=true";
import { default as _91id_93ScEJrUErtkMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/checkout/add-to-order/[id].vue?macro=true";
import { default as indexE5oBabNkmIMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/checkout/index.vue?macro=true";
import { default as indexyP9ASRs3SyMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/club/index.vue?macro=true";
import { default as indexCetnxD6ZgwMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/collectors/index.vue?macro=true";
import { default as indexAjTyCciwetMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/collectors/join/index.vue?macro=true";
import { default as confirm_45emailRvBF2D909nMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/confirm-email.vue?macro=true";
import { default as indexV0QzK1K3bBMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/connoisseurs-wine-club/index.vue?macro=true";
import { default as index40XtC60R35Meta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/connoisseurs-wine-club/join/index.vue?macro=true";
import { default as contact_45usIjWWhTOzDFMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/contact-us.vue?macro=true";
import { default as corporate_45giftingQ4wZ6qu0HfMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/corporate-gifting.vue?macro=true";
import { default as indexirYbYUsagMMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/decanter/index.vue?macro=true";
import { default as indexpyJ7m8XHkUMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/decanter/join/index.vue?macro=true";
import { default as indexsrohXpyh9QMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/discovery-wine-club/index.vue?macro=true";
import { default as indexDf2zySLA7DMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/discovery-wine-club/join/index.vue?macro=true";
import { default as index4mzlL2GtHVMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/en-primeur/index.vue?macro=true";
import { default as indexyFqylohRt0Meta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/error/index.vue?macro=true";
import { default as indexcSYCmlONdqMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/giftcard/index.vue?macro=true";
import { default as paymentXHJlXurBbkMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/giftcard/payment.vue?macro=true";
import { default as termsNxIuNJ61WhMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/giftcard/terms.vue?macro=true";
import { default as thank_45youMhsGEFbwK4Meta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/giftcard/thank-you.vue?macro=true";
import { default as indexAF7VRucIYYMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/index.vue?macro=true";
import { default as inviteglv4GUx1FeMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/invite.vue?macro=true";
import { default as indexd0fFpKNPGsMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/michelin/index.vue?macro=true";
import { default as indexpdkxCdGa9JMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/michelin/join/index.vue?macro=true";
import { default as perfect_45provenance9FO1entAWmMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/perfect-provenance.vue?macro=true";
import { default as indexWVmJkIYzfyMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/podcast/index.vue?macro=true";
import { default as indexCmJU09h0yaMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/podcast/join/index.vue?macro=true";
import { default as _91code_93uoL5X2gB5JMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/redeem-gift/[code].vue?macro=true";
import { default as rimowaalk1PbizTaMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/rimowa.vue?macro=true";
import { default as _91_91slug_93_93G2SU5lKCJLMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/store/[[category]]/[[slug]].vue?macro=true";
import { default as indexYJlGOdTsCfMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/sunset/index.vue?macro=true";
import { default as indexzoujSjslVAMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/sunset/join/index.vue?macro=true";
import { default as indexyBqLxNZ2QGMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/vinovest/index.vue?macro=true";
import { default as indexC6JlhfhFTFMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/vinovest/join/index.vue?macro=true";
import { default as indexPsJWQqynr4Meta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/waitlist/index.vue?macro=true";
import { default as indexTGvgMshSpjMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/waitlist/join/index.vue?macro=true";
import { default as indexeumVm7GhBgMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wheelsup/index.vue?macro=true";
import { default as indexETmJrKbcTlMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wheelsup/join/index.vue?macro=true";
import { default as where_45we_45shipUeS6Jj2ViaMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/where-we-ship.vue?macro=true";
import { default as _91slug_93USPYSfrMheMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wine-club/gifting/[slug].vue?macro=true";
import { default as indexpCW04QeeaXMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wine-club/gifting/index.vue?macro=true";
import { default as indexIzHz6B3frSMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wine-for-normal-people/index.vue?macro=true";
import { default as indexGL1t6v5j5KMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wine-for-normal-people/join/index.vue?macro=true";
import { default as wine_45teampDn4VgRozfMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wine-team.vue?macro=true";
import { default as wsetpyiryRHuQhMeta } from "/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wset.vue?macro=true";
import { default as component_45stubeSSg4kSwWZMeta } from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubeSSg4kSwWZ } from "/home/circleci/wineaccess/nuxt-app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug_wagtail",
    path: "/:slug_wagtail()",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/[slug_wagtail].vue")
  },
  {
    name: "accessibility",
    path: "/accessibility",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accessibility.vue")
  },
  {
    name: "accounts-addresses-addressId-delete",
    path: "/accounts/addresses/:addressId()/delete",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/addresses/[addressId]/delete.vue")
  },
  {
    name: "accounts-addresses-addressId",
    path: "/accounts/addresses/:addressId()",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/addresses/[addressId]/index.vue")
  },
  {
    name: "accounts-addresses-add",
    path: "/accounts/addresses/add",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/addresses/add.vue")
  },
  {
    name: "accounts-addresses",
    path: "/accounts/addresses",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/addresses/index.vue")
  },
  {
    name: "accounts-change-password",
    path: "/accounts/change-password",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/change-password/index.vue")
  },
  {
    name: "accounts-credits",
    path: "/accounts/credits",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/credits/index.vue")
  },
  {
    name: "accounts-email",
    path: "/accounts/email",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/email.vue")
  },
  {
    name: "accounts-orders-id",
    path: "/accounts/orders/:id()",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/orders/[id].vue")
  },
  {
    name: "accounts-orders-gifts",
    path: "/accounts/orders/gifts",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/orders/gifts/index.vue")
  },
  {
    name: "accounts-orders",
    path: "/accounts/orders",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/orders/index.vue")
  },
  {
    name: "accounts-orders-weather-id",
    path: "/accounts/orders/weather/:id()",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/orders/weather/[id].vue")
  },
  {
    name: "accounts-payment_methods-methodId-delete",
    path: "/accounts/payment_methods/:methodId()/delete",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/payment_methods/[methodId]/delete.vue")
  },
  {
    name: "accounts-payment_methods-methodId-update",
    path: "/accounts/payment_methods/:methodId()/update",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/payment_methods/[methodId]/update.vue")
  },
  {
    name: "accounts-payment_methods-add",
    path: "/accounts/payment_methods/add",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/payment_methods/add.vue")
  },
  {
    name: "accounts-payment_methods",
    path: "/accounts/payment_methods",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/payment_methods/index.vue")
  },
  {
    name: "accounts-profile-edit",
    path: "/accounts/profile/edit",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/profile/edit.vue")
  },
  {
    name: "accounts-profile",
    path: "/accounts/profile",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/profile/index.vue")
  },
  {
    name: "accounts-unsubscribe",
    path: "/accounts/unsubscribe",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/accounts/unsubscribe.vue")
  },
  {
    name: "basket-quick-add",
    path: "/basket/quick-add",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/basket/quick-add/index.vue")
  },
  {
    name: "basket-quick-multiple",
    path: "/basket/quick-multiple",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/basket/quick-multiple/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/cart.vue")
  },
  {
    name: "catalog-slug",
    path: "/catalog/:slug()",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/catalog/[slug].vue")
  },
  {
    name: "catalog-category-slug",
    path: "/catalog/category/:slug()",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/catalog/category/[slug].vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/catalog/index.vue")
  },
  {
    name: "cellar-lists-id",
    path: "/cellar/lists/:id()",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/cellar/lists/[id].vue")
  },
  {
    name: "cellar-lists",
    path: "/cellar/lists",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/cellar/lists/index.vue")
  },
  {
    name: "cellar-saved",
    path: "/cellar/saved",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/cellar/saved.vue")
  },
  {
    name: "cellar-wines-slug",
    path: "/cellar/wines/:slug?",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/cellar/wines/[[slug]].vue")
  },
  {
    name: "champagne-club",
    path: "/champagne-club",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/champagne-club/index.vue")
  },
  {
    name: "champagne-club-join",
    path: "/champagne-club/join",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/champagne-club/join/index.vue")
  },
  {
    name: "checkout-add-to-order-id",
    path: "/checkout/add-to-order/:id()",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/checkout/add-to-order/[id].vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: indexE5oBabNkmIMeta || {},
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/checkout/index.vue")
  },
  {
    name: "club",
    path: "/club",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/club/index.vue")
  },
  {
    name: "collectors",
    path: "/collectors",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/collectors/index.vue")
  },
  {
    name: "collectors-join",
    path: "/collectors/join",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/collectors/join/index.vue")
  },
  {
    name: "confirm-email",
    path: "/confirm-email",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/confirm-email.vue")
  },
  {
    name: "connoisseurs-wine-club",
    path: "/connoisseurs-wine-club",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/connoisseurs-wine-club/index.vue")
  },
  {
    name: "connoisseurs-wine-club-join",
    path: "/connoisseurs-wine-club/join",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/connoisseurs-wine-club/join/index.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/contact-us.vue")
  },
  {
    name: "corporate-gifting",
    path: "/corporate-gifting",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/corporate-gifting.vue")
  },
  {
    name: "decanter",
    path: "/decanter",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/decanter/index.vue")
  },
  {
    name: "decanter-join",
    path: "/decanter/join",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/decanter/join/index.vue")
  },
  {
    name: "discovery-wine-club",
    path: "/discovery-wine-club",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/discovery-wine-club/index.vue")
  },
  {
    name: "discovery-wine-club-join",
    path: "/discovery-wine-club/join",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/discovery-wine-club/join/index.vue")
  },
  {
    name: "en-primeur",
    path: "/en-primeur",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/en-primeur/index.vue")
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/error/index.vue")
  },
  {
    name: "giftcard",
    path: "/giftcard",
    meta: indexcSYCmlONdqMeta || {},
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/giftcard/index.vue")
  },
  {
    name: "giftcard-payment",
    path: "/giftcard/payment",
    meta: paymentXHJlXurBbkMeta || {},
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/giftcard/payment.vue")
  },
  {
    name: "giftcard-terms",
    path: "/giftcard/terms",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/giftcard/terms.vue")
  },
  {
    name: "giftcard-thank-you",
    path: "/giftcard/thank-you",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/giftcard/thank-you.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/index.vue")
  },
  {
    name: "invite",
    path: "/invite",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/invite.vue")
  },
  {
    name: "michelin",
    path: "/michelin",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/michelin/index.vue")
  },
  {
    name: "michelin-join",
    path: "/michelin/join",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/michelin/join/index.vue")
  },
  {
    name: "perfect-provenance",
    path: "/perfect-provenance",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/perfect-provenance.vue")
  },
  {
    name: "podcast",
    path: "/podcast",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/podcast/index.vue")
  },
  {
    name: "podcast-join",
    path: "/podcast/join",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/podcast/join/index.vue")
  },
  {
    name: "redeem-gift-code",
    path: "/redeem-gift/:code()",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/redeem-gift/[code].vue")
  },
  {
    name: "rimowa",
    path: "/rimowa",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/rimowa.vue")
  },
  {
    name: "store-category-slug",
    path: "/store/:category?/:slug?",
    meta: _91_91slug_93_93G2SU5lKCJLMeta || {},
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/store/[[category]]/[[slug]].vue")
  },
  {
    name: "sunset",
    path: "/sunset",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/sunset/index.vue")
  },
  {
    name: "sunset-join",
    path: "/sunset/join",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/sunset/join/index.vue")
  },
  {
    name: "vinovest",
    path: "/vinovest",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/vinovest/index.vue")
  },
  {
    name: "vinovest-join",
    path: "/vinovest/join",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/vinovest/join/index.vue")
  },
  {
    name: "waitlist",
    path: "/waitlist",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/waitlist/index.vue")
  },
  {
    name: "waitlist-join",
    path: "/waitlist/join",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/waitlist/join/index.vue")
  },
  {
    name: "wheelsup",
    path: "/wheelsup",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wheelsup/index.vue")
  },
  {
    name: "wheelsup-join",
    path: "/wheelsup/join",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wheelsup/join/index.vue")
  },
  {
    name: "where-we-ship",
    path: "/where-we-ship",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/where-we-ship.vue")
  },
  {
    name: "wine-club-gifting-slug",
    path: "/wine-club/gifting/:slug()",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wine-club/gifting/[slug].vue")
  },
  {
    name: "wine-club-gifting",
    path: "/wine-club/gifting",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wine-club/gifting/index.vue")
  },
  {
    name: "wine-for-normal-people",
    path: "/wine-for-normal-people",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wine-for-normal-people/index.vue")
  },
  {
    name: "wine-for-normal-people-join",
    path: "/wine-for-normal-people/join",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wine-for-normal-people/join/index.vue")
  },
  {
    name: "wine-team",
    path: "/wine-team",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wine-team.vue")
  },
  {
    name: "wset",
    path: "/wset",
    component: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/pages/wset.vue")
  },
  {
    name: component_45stubeSSg4kSwWZMeta?.name,
    path: "/offer",
    component: component_45stubeSSg4kSwWZ
  }
]